import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ClockProperties } from "@lib/titan2/dist/game/control/properties/ClockProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { LanguageManager, Locale } from "@lib/titan2/dist/game/manager/LanguageManager";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { GameStyle } from "../style/GameStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { GameFontStyle } from "../style/GameFontStyle";
import { Point } from "pixi.js";
import { AbstractMessageBarProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractMessageBarProperties";
/**
 * GameMessageBarProperties.ts
 */
export class GameMessageBarProperties extends AbstractMessageBarProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.gameIdProperties.equals(other.gameIdProperties) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.clockProperties.equals(other.clockProperties);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.NAVIGATION_BACKGROUND, GameStyle.MODULE);
        this.backgroundProperties.visible = false;
        this.gameIdProperties = new TextFieldProperties(FontStyle.MESSAGE_BAR, null, null, ControlConstants.LEFT);
        this.clockProperties = new ClockProperties(FontStyle.CLOCK);
        this.fieldOffset = 17;
        this.fullScreenOffset = 75;
        this.messageFieldProperties = new TextFieldProperties(GameFontStyle.GAME_MESSAGES, null, null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(600, 60));
        this.messageFieldProperties.autoResize = true;
        this.messageInterval = 3000;
        this.maxLength = new Dictionary();
        this.maxLength.setValue(Locale.ENGLISH, 36);
    }
    getMaxLength() {
        let locale = LanguageManager.getInstance().getLocale();
        if (!this.maxLength.containsKey(locale)) {
            locale = Locale.ENGLISH;
        }
        return this.maxLength.getValue(locale);
    }
}
//# sourceMappingURL=GameMessageBarProperties.js.map